import { useRolePermissions } from "@Front/Stores/RolePermissionsStore";
import type { Matrix } from "@Front/Stores/hooks/useRolePermissionsController";

/**
 * Accès lecture seule à la matrice permissions (hors périmètre ESLint « office-scoped » DesignSystem).
 */
export function useRolePermissionsMatrixSnapshot(): Matrix {
	const { matrix } = useRolePermissions();
	return matrix;
}
